/** "1.25 s" for short durations, "m:ss" from one minute. */
export const formatSeconds = (s: number) =>
  s < 60 ? `${s.toFixed(s < 10 ? 2 : 1)} s` : `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`;
